import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

const StyledPartialIndicator = styled.span`
  color: ${getColor('torchRed')};
  font-weight: bold;
`;

const PartialIndicator = () => {
  return <StyledPartialIndicator>*</StyledPartialIndicator>;
};

export default PartialIndicator;
